var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"thisComponent":_vm.getPopup,"show":_vm.getPopup !== null,"hasClose":_vm.getPopupHasClose},on:{"close":function($event){return _vm.showPopup(null)}}})}
var staticRenderFns = []

export { render, staticRenderFns }